import { ConfigurationOntology } from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.model'
import { store } from '@/store/store'

export interface ConfigurationOntologyProtocol extends ConfigurationOntology {
    protocolId: number
}

export interface ConfigurationLocalAssaysProtocolsModalOntologiesFormState {
    ontologies: ConfigurationOntologyProtocol[]
    laboratoryId: number
}
export const initialConfigurationLocalAssaysProtocolsModalOntologiesFormState =
    (): ConfigurationLocalAssaysProtocolsModalOntologiesFormState => ({
        ontologies: [],
        laboratoryId: store.getters.labId
    })
